module.exports = "Content Tile\n===\n\nA tile meant to hold content ❤"


//////////////////
// WEBPACK FOOTER
// ./src/ContentTile/README.md
// module id = 150
// module chunks = 0